import { uniq } from "lodash";
import Config from "../../config";
import { BaseChannelConversationItem, ChannelMessageItem, ChannelConversationItem } from "../../models/conversations";
import { AuthService } from "../../services/AuthService";
import store from '../../stores/app-store';
import { UpdateChannelConversationHistory } from "../../actions";
import { ChannelDeliveryStatus, ChannelType } from "../../models/channels/channels.model";
import { v4 as uuid } from "uuid";
import { ClientReadableStream } from "grpc-web";
import { MessagesClient } from "../messages/messages_grpc_web_pb";
import { MessageData, MessageRequest, MessageResponse, ParticipantData, ParticipantResponse } from "../messages/messages_pb";
import { updateAiCreditsCount, updateChannelConversations } from "../../reducers/reducer";
import { ChannelAuthService } from "../../services/ChannelAuthService";

var client = new MessagesClient(Config.FALKON_CONNECT_GRPC_API);
var participantsStream: ClientReadableStream<ParticipantResponse>;
var messagesStream: ClientReadableStream<MessageResponse>;

var clientid = sessionStorage.getItem('grpcId');

if (!clientid) {
    clientid = uuid()
    sessionStorage.setItem('grpcId', clientid)
}


export const ListenMessageParticipants = () => {
    const messgaeRequest = new MessageRequest();
    messgaeRequest.setToken(AuthService.getToken().access_token);
    messgaeRequest.setClientid(clientid);
    participantsStream = client.participantSubscriber(messgaeRequest);
    participantsStream.on('data', handleMessageParticipantsData);
    participantsStream.on('end', ListenMessageParticipants);
    participantsStream.on('error', ListenMessageParticipants);
}

export const ListenMessages = () => {
    const messgaeRequest = new MessageRequest();
    messgaeRequest.setToken(AuthService.getToken().access_token)
    messgaeRequest.setClientid(clientid)
    messagesStream = client.messageSubscriber(messgaeRequest)
    messagesStream.on('data', handleMessagesData)
    messagesStream.on('end', ListenMessages)
    messagesStream.on('error', ListenMessages)
}

export const ListenLiveChatMessageParticipants = () => {
    const messgaeRequest = new MessageRequest();
    messgaeRequest.setToken(ChannelAuthService.getLivechatToken().access_token);
    messgaeRequest.setClientid(clientid);
    participantsStream = client.participantSubscriber(messgaeRequest);
    participantsStream.on('data', handleMessageParticipantsData);
    participantsStream.on('end', ListenLiveChatMessageParticipants);
    participantsStream.on('error', ListenLiveChatMessageParticipants);
}

export const ListenLiveChatMessages = () => {
    const messgaeRequest = new MessageRequest();
    messgaeRequest.setToken(ChannelAuthService.getLivechatToken().access_token)
    messgaeRequest.setClientid(clientid)
    messagesStream = client.messageSubscriber(messgaeRequest)
    messagesStream.on('data', handleMessagesData)
    messagesStream.on('end', ListenLiveChatMessages)
    messagesStream.on('error', ListenLiveChatMessages)
}


const handleMessageParticipantsData = (res) => {
    const conversations = res.getDataList().map(x => x.toObject());
    const cons = conversations.map(mapGrpcDataToChannelConversationItem);
    const filteredCons = cons.filter(x => x);
    // console.log(conversations, cons, filteredCons);
    if (!!filteredCons[0].Message) {
        store?.dispatch(updateChannelConversations(filteredCons))
    }
    store?.dispatch(updateAiCreditsCount(conversations[0]?.aiCredits))
}

const handleMessagesData = (res) => {

    const data = res.getDataList().map(x => x.toObject());
    const messages = data.map(mapGrpcDataToChannelMessage);
    const conIds = uniq(messages.map(x => x.ConversationID));

    for (const id of conIds) {
        console.log("message data", messages.filter(x => x.ConversationID === id));
        UpdateChannelConversationHistory(store.dispatch, id.toString(), messages.filter(x => x.ConversationID === id), true);
    }
}


export const RemoveMessagesListener = () => {
    console.log("RemoveMessagesListener")
    messagesStream.removeListener("data", handleMessagesData)
}

export const RemoveMessageParticipantsListener = () => {
    console.log("RemoveMessageParticipantsListener")
    participantsStream.removeListener("data", handleMessageParticipantsData)
}

export const RemoveLiveChatMessagesListener = () => {
    console.log("RemoveMessagesListener")
    messagesStream.removeListener("data", handleMessagesData)
}

export const RemoveLiveChatMessageParticipantsListener = () => {
    console.log("RemoveMessageParticipantsListener")
    participantsStream.removeListener("data", handleMessageParticipantsData)
}


const mapGrpcDataToChannelMessage = (x: MessageData.AsObject): ChannelMessageItem => {
    return {
        ID: x.id,
        SenderID: x.senderId,
        Message: x.message.value,
        MessageType: x.message.type,
        MessagePayload: x.message?.payload,
        CreatedAt: x.createdAt,
        IsOutbound: !x.inbound,
        ConversationID: x.participantId,
        IsUnread: x.isUnread,
        DeliverAt: x.deliveredAt,
        ReadAt: x.readAt,
        DeliveryStatus: x.status as ChannelDeliveryStatus,
        MessageCategory: x?.messageCategory,
        Reaction: x.reaction ? {
            Type: x.reaction?.reaction,
            Emoji: x.reaction?.emoji
        } : undefined,
    } as ChannelMessageItem;
}

const mapGrpcDataToChannelConversationItem = (x: ParticipantData.AsObject): ChannelConversationItem => {
    console.log("ParticipantsData", x)
    switch (x.channelType) {
        case ChannelType.FACEBOOK:
        case ChannelType.INSTAGRAM:
        case ChannelType.LIVE_CHAT:
        case ChannelType.GOOGLE_BUSINESS:
            const data: any = JSON.parse(x.data)
            return {
                ID: x.id,
                Name: x.name,
                UserName: x.username,
                AccountId: x.accountId,
                FirstName: data.first_name,
                LastName: data.last_name,
                ProfilePicLink: data.profile_pic,
                Status: x.status,
                UpdatedBy: x.updatedBy,
                MessageDateTime: x.messagesList[0]?.createdAt > x.updatedAt ? x.messagesList[0]?.createdAt : x.updatedAt,
                Message: x.messagesList[0]?.message.value,
                MessageType: x.messagesList[0]?.message.type,
                MessageID: x.messagesList[0]?.id,
                IsOutbound: !x.messagesList[0]?.inbound,
                MessagePayload: x.messagesList[0]?.message.payload,
                Type: x.channelType,
                IsArchived: x.isArchived,
                UnReadCount: x.unreadCount,
                OnlineStatus: x.onlineStatus,
                UserTyping: x.isTyping.userTyping,
                BusinessTyping: x.isTyping.businessTyping,
                MessageStatus: x.messagesList[0]?.status,
                Ticket: {
                    Assigned_To: x.ticket.assignedTo,
                    Priority: x.ticket.priority,
                    Status: x.ticket.status,
                    History: x.ticket.historyList.map(x => { return { Action: x.action, Time: x.time, By: x.by } })
                },
                TypingBy: x.isTyping?.userName,
            } as unknown as ChannelConversationItem
    }
}

//protoc *.proto --js_out=import_style=commonjs:. --grpc-web_out=import_style=commonjs+dts,mode=grpcwebtext:.     
